export var OI_ALL_GRAPH = "OI_ALL_GRAPH";
export var OI_CHART_GRAPH = "OI_CHART_GRAPH";
export var OPTION_CHAIN_GRAPH_ERROR = "OPTION_CHAIN_GRAPH_ERROR";
export var OI_CHANGE_GRAPH = "OI_CHANGE_GRAPH";
export var OPTION_PAIN_GRAPH = "OPTION_PAIN_GRAPH";
export var OPTION_CHAIN_GRPAH_HIDE_ERROR = "OPTION_CHAIN_GRPAH_HIDE_ERROR";
export var OPTION_CHAIN_GRPAH_START_LOADER = "OPTION_CHAIN_GRPAH_START_LOADER";
export var OPTION_CHAIN_GRPAH_STOP_LOADER = "OPTION_CHAIN_GRPAH_STOP_LOADER";
export var OPTION_CHAIN_GRAPH_EXPIRY_DATE_DATA = "OPTION_CHAIN_GRAPH_EXPIRY_DATE_DATA";
